import React, { useEffect, useRef, useState } from "react";
import { FaCopy, FaExternalLinkAlt } from "react-icons/fa";
import { safeHttpUrl } from "../../../utils/applicationLinks";
import { applicationLinksText } from "./applicationLinksText";
import "./applicationLinks.css";

// Reviewer view of an application's links: only the name is shown; the name
// opens the URL, Copy copies the URL itself. A stored value that is not an
// http(s) URL is shown as plain text and never becomes a link.
const ApplicationLinksList = ({ links = [], infoSource }) => {
  const text = applicationLinksText(infoSource);
  const [copied, setCopied] = useState({ index: -1, failed: false });
  const timer = useRef(null);
  useEffect(() => () => clearTimeout(timer.current), []);
  const copy = async (index, url) => {
    clearTimeout(timer.current);
    try {
      await navigator.clipboard.writeText(url);
      setCopied({ index, failed: false });
    } catch (_) {
      setCopied({ index, failed: true });
    }
    timer.current = setTimeout(() => setCopied({ index: -1, failed: false }), 1600);
  };

  return (
    <section className="application-links-view">
      <h4>{text("socialLinks")}</h4>
      {!links.length && <p className="application-links-empty">{text("noSocialLinks")}</p>}
      {!!links.length && (
        <ul>
          {links.map((link, index) => {
            const url = safeHttpUrl(link.url);
            return (
              <li key={`${index}-${link.name}`}>
                {url
                  ? <a href={url} target="_blank" rel="noopener noreferrer">{link.name}<FaExternalLinkAlt aria-hidden="true" /></a>
                  : <span>{link.name}</span>}
                {url && (
                  <button type="button" onClick={() => copy(index, url)} aria-label={`${text("copyLink")}: ${link.name}`} title={text("copyLink")}>
                    <FaCopy aria-hidden="true" />
                  </button>
                )}
                {copied.index === index && <small role="status">{copied.failed ? text("copyUnavailable") : text("linkCopied")}</small>}
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
};

export default ApplicationLinksList;
